import './assets/fonts/font.css';
import './styles/root.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { reduxStore } from './store/store';
import App from './App';
import { Amplify } from 'aws-amplify';
import amplifyConfig from "./amplifyconfiguration.json";

Amplify.configure(amplifyConfig);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
  <Provider store={reduxStore}>
    <App />
  </Provider>
  // </React.StrictMode>
);
